import React from 'react';

// Import images
import CalendarImage from '../../images/Calendar.png';
import PeopleImage from '../../images/People.png';
import ReceiptImage from '../../images/Reciept.png';

const WhyUs: React.FC = () => {
  return (
    <div className="py-6">
      {/* Mobile layout: compact list */}
      <div className="md:hidden max-w-4xl mx-auto px-8">
        <h2 className="text-3xl font-bold text-center mb-4">Benefits</h2>
        <div className="space-y-4">
          {/* Benefit 1 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <img src={CalendarImage} alt="Calendar" className="w-12 h-12" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-black mb-1">
                Plan your entire trip up to 12 months in advance.
              </h3>
            </div>
          </div>
          
          {/* Benefit 2 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <img src={ReceiptImage} alt="Receipt" className="w-12 h-12" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-black mb-1">
                All bookings and receipts organized in one place.
              </h3>
            </div>
          </div>
          
          {/* Benefit 3 */}
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <img src={PeopleImage} alt="People" className="w-12 h-12" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-black mb-1">
                Share your trip plans with friends and family.
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop layout: original large cards */}
      <div className="hidden md:block text-center font-buenos-aires">
        <h2 className="text-4xl text-[#4b96a6] font-black mb-12 mt-0">Why us?</h2>
        <div className="flex justify-center flex-wrap gap-12 px-8 mb-12">
          <div className="flex-1 min-w-[300px] p-8 border-2 border-gray-200 rounded-[4vh] text-left bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 font-montserrat">
            <img src={CalendarImage} alt="Calendar" className="w-24 h-auto mb-6" />
            <h3 className="text-2xl font-bold text-black mb-4">Easy Planning, in one place</h3>
            <p className="text-lg text-black">Plan your trip here and then some extra waffle about how great our site is and shizzle.</p>
          </div>
          <div className="flex-1 min-w-[300px] p-8 border-2 border-gray-200 rounded-[4vh] text-left bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 font-montserrat">
            <img src={ReceiptImage} alt="Receipt" className="w-24 h-auto mb-6" />
            <h3 className="text-2xl font-bold text-black mb-4">Collect all your receipts</h3>
            <p className="text-lg text-black">Keep all receipts and extra information in one place and then just say loads of random shite so that it looks goood.</p>
          </div>
          <div className="flex-1 min-w-[300px] p-8 border-2 border-gray-200 rounded-[4vh] text-left bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 font-montserrat">
            <img src={PeopleImage} alt="People" className="w-24 h-auto mb-6" />
            <h3 className="text-2xl font-bold text-black mb-4">Keep everyone in the loop</h3>
            <p className="text-lg text-black">Ability to share with friends and how amazing Ben's hair and loads of random shite like this to fill the amazing space.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
